import { Gpt } from '@pcln/ad-unit'
import { SearchFormCard } from '@pcln/horizon-search-form'
import { Box, Card, Container, Hide, theme } from 'pcln-design-system'
import { useState } from 'react'
import styled from 'styled-components'

import ComponentMetricsBoundary from '@/components/ComponentMetricsBoundary/ComponentMetricsBoundary'
import HeroImageParallax from '@/components/Heros/HeroImageParallax'
import SearchFormProvider from '@/context/SearchFormContext'
import useContentfulSearchFormHeadlines from '@/hooks/useContentfulSearchFormHeadlines'
import useExpressDealDialog from '@/hooks/useExpressDealDialog'
import type { LOCATION_SEARCH_TYPE } from '@/types'

import ConditionalRender, { Experiment, Original } from '../ConditionalRender'
import { ExpressDealDialogExperiment } from './ExpressDeal/ExpressDealDialogExperiment'
import HorizonHotelForm from './HorizonForm/HorizonHotelForm'
import HotelsContent from './HotelsContent'
import HotelsSearchFormHeader from './HotelsSearchFormHeader'
import Form from './SearchForm/Form'
import { handleSubmitForHotels } from './SearchForm/utils'

const BlockFlex = styled(Box)`
  position: relative;
  z-index: 1;
  ${theme.mediaQueries[3]} {
    display: flex;
    align-items: flex-start;
  }
`

const HideAdUnit = styled(Hide)`
  text-align: center;
  position: relative;
  margin: 16px;
  min-height: 100px;
  ${theme.mediaQueries[3]} {
    width: 300px;
    flex: none;
    margin: 0 16px;
  }
`

function HotelsDesktop() {
  const { isOpen, closeDialog } = useExpressDealDialog()
  const [location, setLocation] = useState<LOCATION_SEARCH_TYPE | undefined>()
  const searchForm = useContentfulSearchFormHeadlines('searchForm')
  const subheadline = searchForm?.subheadline ?? ''
  return (
    <Box>
      <ExpressDealDialogExperiment isOpen={isOpen} closeDialog={closeDialog} />
      <HeroImageParallax
        isScrollable
        gptId='div-gpt-ad-1509978154282-0'
        slot='/3102/priceline.dart/hotel_homepage_hero_image'
      >
        <Container>
          <BlockFlex mx={3} py={[3, null, null, null, 5]}>
            <ComponentMetricsBoundary componentId='SearchFormHotels'>
              <ConditionalRender experimentCode='USB_SEARCH_HOTEL_LANDING_HORIZON'>
                <Original>
                  <Card
                    width={1}
                    borderWidth={0}
                    color='background.lightest'
                    borderRadius='2xl'
                    boxShadowSize='xl'
                  >
                    <Box p={3} width={1}>
                      <HotelsSearchFormHeader location={location} subheadline={subheadline} />
                      <Form onSubmit={handleSubmitForHotels} setLocation={setLocation} showMultiHotel />
                    </Box>
                  </Card>
                </Original>
                <Experiment>
                  <SearchFormCard variant='panel' width='full'>
                    <HotelsSearchFormHeader location={location} subheadline={subheadline} />
                    <SearchFormProvider>
                      <HorizonHotelForm
                        onSubmit={handleSubmitForHotels}
                        setLocation={setLocation}
                        showHotelTypeButtons
                        pageName='landing'
                      />
                    </SearchFormProvider>
                  </SearchFormCard>
                </Experiment>
              </ConditionalRender>
            </ComponentMetricsBoundary>
            <HideAdUnit xs sm>
              <Gpt render={() => <div id='div-gpt-ad-1510170073577-0' />} />
            </HideAdUnit>
          </BlockFlex>
        </Container>
      </HeroImageParallax>
      <Hide xs sm color='background.lightest'>
        <HotelsContent />
      </Hide>
    </Box>
  )
}

export default HotelsDesktop
